(ns common.schema.entities.decision-participant-options
  (:require
   [common.util :as cu]))

; clarify translations
(def vote-options
  [{:key   :decision-participant.vote/in-favor
    :label "In favor"}
   {:key   :decision-participant.vote/against
    :label "Against"}
   {:key   :decision-participant.vote/empty-vote
    :label "Empty vote"}
   {:key   :decision-participant.vote/disqualified
    :label "Disqualified"}])

(def attendance-options
  [{:key   :decision-participant.attendance/attended
    :label "Attended"}
   {:key   :decision-participant.attendance/partially-attended
    :label "Partially attended"}
   {:key   :decision-participant.attendance/did-not-attend
    :label "Did not attend"}
   {:key   :decision-participant.attendance/other
    :label "Other (specify in notes)"}])

(defn get-label
  [k]
  (or (->> vote-options
           (cu/filter-by :key k)
           (first)
           :label)
      (->> attendance-options
           (cu/filter-by :key k)
           (first)
           :label)))
